import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { InstanceService } from '../../services/instance.service';
import { getDeepestRouteSnapshot } from '@finra/rampdi-forms-common';
import { ActivatedRoute } from '@angular/router';
import { environment, Versions } from 'projects/app-mu3-form/src/environments/environment';
import { DisplayRulesService } from '../../services/display-rules.service';
import { ProfilesService } from '../../services/profile.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-post-submission',
  templateUrl: './post-submission.component.html',
  styleUrls: ['./post-submission.component.scss'],
})
export class PostSubmissionComponent implements OnInit, OnDestroy {
  invoiceId: string;
  confirmationNumber: string;
  individualEntityId: string;
  individualName: any;
  notificationEmail: string;
  licenseDetails: string[] = [];
  hasLicenses = false;
  hasPayment = false;
  invoiceDetails: any;
  isCompanyUser = false;
  hasNewLicenseApplication = false;
  relationshipDetailsUrl = '';
  profilesService = inject(ProfilesService);
  dataLoaded = false;
  private individualSummarySubscription: Subscription;

  constructor(
    private instanceService: InstanceService,
    private route: ActivatedRoute,
    private DS: DisplayRulesService,
  ) {}

  ngOnInit() {
    this.notificationEmail = 'your registered email';
    this.individualName =
      this.instanceService.getInitialInstance()?.collectedData?.individualInformation?.personalInformation
        ?.individualName ||
      this.instanceService.currentInstance?.collectedData?.individualInformation?.personalInformation?.individualName;
    this.route.queryParams.subscribe((params) => {
      this.invoiceId = params.invoiceId;
      this.confirmationNumber = params.confirmationNumber;
      if (this.invoiceId) {
        this.getInvoiceDetails();
      }
    });
    this.individualEntityId = String(this.instanceService.currentInstance?.instanceMetadata?.target['subjectId'] ?? '');
    if (this.individualEntityId) {
      this.individualSummarySubscription = this.profilesService.individualSummary$.subscribe((resp) => {
        if (resp?.data?.getIndividualSummary?.contactDetails?.email?.notificationEmail) {
          this.notificationEmail = resp.data.getIndividualSummary.contactDetails.email.notificationEmail;
          this.dataLoaded = true;
        }
      });
      this.profilesService.getIndividualSummary(this.individualEntityId);
    } else {
      this.dataLoaded = true;
    }
    const licenses: any[] = this.instanceService.currentInstance?.collectedData?.licenses;
    if (licenses && licenses.length > 0) {
      this.licenseDetails = licenses
        .map((license) => `${license.regulatorDescription || ''} ${license.licenseTypeDescription || ''}`)
        .filter((desc) => desc.trim() !== '');
      this.hasLicenses = this.licenseDetails.length > 0;
    }
    this.isCompanyUser = this.DS.userPermissions.isCompanyUser;
    if (this.isCompanyUser && licenses?.some((license: any) => !license.licenseStatusDescription)) {
      this.hasNewLicenseApplication = true;
      const employmentHistory = this.instanceService.currentInstance?.collectedData?.employmentHistory;
      const companyEntityId = this.instanceService.currentInstance?.instanceMetadata?.target?.['entityId'];
      const companyRelationship = employmentHistory?.find(
        (emp) => emp.status === 'COMPANYRELATIONSHIP' && !emp.employmentToDate && emp.entityId === companyEntityId,
      );
      const relationshipSegment = companyRelationship?.companyRelationshipId
        ? `/relationship/${companyRelationship.companyRelationshipId}`
        : '';
      this.relationshipDetailsUrl = `${environment.gatewayOrigin}${environment.dxtBasePath}/entity-profile/individual-summary/${this.individualEntityId}${relationshipSegment}?activeTab=relationships`;
    }
  }

  getInvoiceDetails() {
    // Invoice/payment not available in MU3
    this.hasPayment = false;
  }

  openInvoiceInfoUrl() {
    const currentEnvVersion =
      environment.versions[
        (this.instanceService.currentInstance.templateVersion ?? environment.currentVersion) as Versions
      ];
    const url = currentEnvVersion.urls.invoiceInfoUrl + `=${this.invoiceId}`;
    window.open(url, '_blank');
  }

  openOutstandingIRs() {
    const currentEnvVersion =
      environment.versions[
        (this.instanceService.currentInstance.templateVersion ?? environment.currentVersion) as Versions
      ];
    const url = this.isCompanyUser ? currentEnvVersion.urls.taskManagement : currentEnvVersion.urls.workManagement;
    window.open(`${url}?tab=IR+Action+Required`, '_self');
  }

  finishRouting() {
    const currentEnvVersion =
      environment.versions[
        (this.instanceService.currentInstance.templateVersion ?? environment.currentVersion) as Versions
      ];
    const url = this.isCompanyUser
      ? currentEnvVersion.urls.workManagement
      : currentEnvVersion.urls.individualProfile + '?activeTab=home';
    window.open(url, '_self');
  }

  getSnapShot() {
    return getDeepestRouteSnapshot(this.route)?.data;
  }

  ngOnDestroy() {
    if (this.individualSummarySubscription) {
      this.individualSummarySubscription.unsubscribe();
    }
  }
}
